<modal-layout-right (close)="close()">
    <ng-container ngProjectAs="[modalTitle]">
        <h4 class="h3">{{'Specifications' | translate}}</h4>
    </ng-container>

    <div ngProjectAs="[modalBody]">
        @for (sectionId of data.sections ; track $index; let isLast = $last; let isEven = $even) {
        <div class="w-6 p-a p-b-0"
             [ngClass]="isEven ? 'p-r-0' : 'p-r'">
            <cms-specification-section-item class="block"
                                            [styleVariant]="'modal'"
                                            [variant]="'specification-section' + sectionId" />
        </div>
        }
    </div>
</modal-layout-right>